import * as _ from "lodash";
import * as actionTypes from "../mutation-types";
import mutationTypesTid6 from "../tenantSpecificModules/storeModulesTid6/mutationTypesTid6";
import * as Utils from "../../libraries/utils";
import LoggerProvider from "../../providers/LoggerProvider";

export default {
	state: {
		isReady: false,
		isError: false,
		accountInfo: null,
		loading: false,
		error: null
	},
	mutations: {
		[actionTypes.SET_GIGYA_READY](state, payload) {
			state.isReady = payload;
		},
		[actionTypes.SET_GIGYA_ERROR](state, payload) {
			state.isError = payload.isGigyaError;
			state.error = payload.errorMessage;
		},
		[actionTypes.SET_GIGYA_ACCOUNT_INFO](state, payload) {
			state.accountInfo = payload;
		},
		[actionTypes.SET_GIGYA_LOADING](state, payload) {
			state.loading = payload;
		}
	},
	actions: {
		async [actionTypes.INIT_GIGYA_SESSION]({ commit, dispatch }) {
			commit(actionTypes.SET_GIGYA_READY, true);
			await dispatch(actionTypes.FETCH_GIGYA_ACCOUNT_INFO, { retries: 3, delay: 1000 });
		},
		[actionTypes.SET_GIGYA_ACCOUNT_INFO]: ({ commit, getters }, payload) => {
			commit(actionTypes.SET_GIGYA_ACCOUNT_INFO, payload);

			const { cjrTrackingId, isConsentGranted, userEmail } = payload;

			commit(mutationTypesTid6.SET_USER_EMAIL, userEmail);
			commit(mutationTypesTid6.SET_CJR_TRACKING_ID, null);

			const maskedEmail =  Utils.maskEmail(userEmail);

			const logData = getters.isGigyaError
				? {
					isGigyaError: true,
					checkSGLoyaltyConsentFT: getters.featureToggles.checkSGLoyaltyConsent
				}
				: {
					cjrTrackingId,
					isConsentGranted,
					userEmail: maskedEmail,
					checkSGLoyaltyConsentFT: getters.featureToggles.checkSGLoyaltyConsent
				};

			LoggerProvider.logEvent({
				message: "Account info updated",
				eventName: `gigya module/SET_GIGYA_ACCOUNT_INFO`,
				eventCategory: "Gigya SDK",
				eventDomain: "LoyaltyUserTracking",
				data: logData
			});

			if (getters.featureToggles.checkSGLoyaltyConsent && !isConsentGranted) {
				// No consent
				commit(mutationTypesTid6.RESET_LOYALTY_DATA);
				return;
			}

			commit(mutationTypesTid6.SET_CJR_TRACKING_ID, cjrTrackingId);
		},
		async [actionTypes.OBTAIN_NEW_JWT]() {
			return new Promise((resolve, reject) => {
				if (!window.gigya) {
					return reject(new Error("Gigya SDK is not loaded"));
				}

				window.gigya.accounts.getJWT({
					callback: async function (jwtResponse) {
						// TODO: remove when testing is done >>
						// self.logInfo.logs.push({
						// 	source: "getLoyaltyOffers",
						// 	step: "execution"
						// });
						// <<

						if (jwtResponse.errorCode !== 0) {
							// TODO: remove when testing is done >>
							// self.logInfo.logs.push({
							// 	source: "getLoyaltyOffers",
							// 	errorCode: jwtResponse.errorCode
							// });
							// <<
							return reject(
								new Error("Gigya JWT failed: " + jwtResponse.errorCode)
							);
						}

						return resolve(jwtResponse.id_token);
					}
				});
			});
		},
		[actionTypes.FETCH_GIGYA_ACCOUNT_INFO]({ commit, dispatch }, { retries, delay }) {
			return new Promise((resolve, reject) => {
				commit(actionTypes.SET_GIGYA_LOADING, true);

				const tryRequest = (attemptsLeft) => {
					window.gigya.accounts.getAccountInfo({
						callback: (response) => {
							if (response.errorCode === 0) {
								commit(actionTypes.SET_GIGYA_READY, true);

								const isConsentGranted = _.get(response, "preferences.profiling.dk.carlsjr.customerprogram.isConsentGranted");

								const data = {
									cjrTrackingId: response.data.tracking.cjrTrackingId,
									userEmail: response.profile.email,
									isConsentGranted
								};

								dispatch(actionTypes.SET_GIGYA_ACCOUNT_INFO, data);
								commit(actionTypes.SET_GIGYA_LOADING, false);

								resolve(null);
							} else if (attemptsLeft > 0 && response.errorCode !== 403005) {
								// 403005 - "Account is not found"
								setTimeout(() => tryRequest(attemptsLeft - 1), delay);
							} else {
								const errorMessage = response.errorMessage || "Failed to load account info";
								const errorCode = response.errorCode || -1;

								commit(actionTypes.SET_GIGYA_ERROR, {
									isGigyaError: true,
									errorMessage: `${errorMessage} - errorCode: ${errorCode}`
								});
								commit(actionTypes.SET_GIGYA_LOADING, false);

								LoggerProvider.logEvent({
									message: "Account info not received",
									eventName: `gigya module/FETCH_GIGYA_ACCOUNT_INFO`,
									eventCategory: "Gigya SDK",
									eventDomain: "LoyaltyUserTracking",
									data: {
										isGigyaError: true,
										errorMessage: response.errorMessage,
										responseErrorCode: response.errorCode
									}
								});

								reject({ errorMessage, errorCode });
							}
						}
					});
				};

				tryRequest(retries);
			});
		}
	},
	getters: {
		gigyaAccountInfo: state => state.accountInfo,
		isGigyaReady: state => state.isReady,
		isGigyaError: state => state.isError,
		gigyaError: state => state.error
	}
};
